import { createFileRoute } from "@tanstack/react-router";
import SportPreviewLanding from "@/pages/SportPreviewLanding";
import { MainLayout } from "@/components/layout/MainLayout";
import { socialMeta } from "@/lib/routeSocial";
import { findSportPreview } from "@/lib/sportPreviewLandings";

export const Route = createFileRoute("/predictions/horse-racing-today")({
  head: () => {
    const preview = findSportPreview("horse-racing-today");
    return {
      meta: socialMeta({
        seo: { topics: ["horseRacing"] },
        ...(preview?.keywords ? { keywords: preview.keywords } : {}),
        title: preview?.title ?? "Sport Predictions | Statlign",
        description:
          preview?.description ??
          "Predictions, odds and model reasoning across every sport Statlign covers.",
      }),
    };
  },
  component: () => (
    <MainLayout>
      <SportPreviewLanding />
    </MainLayout>
  ),
});
